import React from 'react';
import { Progress } from 'antd';
import { Card } from 'antd';

import './PrognosisChart.css';

const ProgressGraph = (props) => {

    return (
        <div className="progress-graph">
            <Card
                style={{
                    width: 300,
                    margin:20
                }}
            >
                <h2 className="score-type">{props.name}</h2>
                <Progress
                    type="circle"
                    percent={props.percent}
                    strokeColor={props.color}
                    strokeWidth={15}
                />
                <h2 className="title">{props.title}</h2>
                <h3 className="description">{props.description}</h3>
            </Card>
        </div>
    )
}

export default ProgressGraph;